<mat-card class="sticky invWrapper">
    <div class="fx-row fx-align-space-between-center">
      <div class="fx-row fx-align-start-center fx-flex-30" id="header__wrapper">
        <app-count-header title="{{inventory?.invBatchName}}"></app-count-header>
      </div>
      <h3 class="text-center fx-flex-30">{{ "invoiceReport" | translate }}</h3>
      <div class="flex fx-align-end-center fx-flex-30 invButton__wrapper">
        <div class="fx-row">
          <app-select-report></app-select-report>
          <button mat-raised-button color="primary" (click)="generatePDF()" class="fx-align-simple-center">
            {{ "generatePDF" | translate }}
          </button>
        </div>
      </div>
    </div>
  </mat-card>
  
  <mat-card class="card-body">
   <app-mid-header [inventory]="inventory"></app-mid-header>
    <div class="fixed-table">
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8"
        width="100%" id="main-table">
  
        <ng-container matColumnDef="prdNameEn">
          <mat-header-cell *matHeaderCellDef> {{ "productDescription" | translate }} </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-header"> 
            <span class="mobile-label">{{ "productDescription" | translate }}</span>
            <span [innerHTML]="element?.prdNameEn"></span>
          </mat-cell>
        </ng-container>
  
        <ng-container matColumnDef="invitmCount">
          <mat-header-cell *matHeaderCellDef>{{ "quantity" | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-header"> 
            <span class="mobile-label">{{ "quantity" | translate }}</span>
            <span>{{element?.invitmCount}}</span></mat-cell>
        </ng-container>
  
        <ng-container matColumnDef="prdRetail">
          <mat-header-cell *matHeaderCellDef class="text-center">{{ "price" | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element" class="text-center flex-header"> 
            <span class="mobile-label">{{ "inventory.count" | translate }}</span>
            <span>${{ element?.prdRetail }}</span></mat-cell>
        </ng-container>
  
        <ng-container matColumnDef="total">
          <mat-header-cell *matHeaderCellDef>{{ "total" | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element" class="text-center flex-header"> 
            <span class="mobile-label">{{ "total" | translate }}</span>
            <span>${{ element?.total }}</span>
          </mat-cell>
        </ng-container>
  
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onNavigate(row.prdID)"></mat-row>
        <div *ngIf="dataSource.length == 0">
          No Records Found!
        </div>
      </table>
  
      <br />
      <br />
      <table class="fx-row fx-align-end-center">
        <tbody>
          <tr>
            <td class="pb-15"><strong>Sub Total:</strong></td>
            <td class="pb-15" width="100px" class="text-right px-15">${{subTotal?.toFixed(2)}}</td>
          </tr>
          <tr *ngIf="tax1 != null">
            <td class="pb-15"><strong>{{tax1.name}} {{tax1.value}}%</strong></td>
            <td class="pb-15" width="100px" class="text-right px-15">${{tax1?.amount}}</td>
          </tr>
          <tr *ngIf="tax2 != null">
            <td class="pb-15"><strong>{{tax2.name}} {{tax2.value}}%</strong></td>
            <td class="pb-15" width="100px" class="text-right px-15">${{tax2?.amount}}</td>
          </tr>
          <tr>
            <td><strong>Total:</strong></td>
            <td  width="100px" class="text-right px-15">${{total}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </mat-card>